import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
const variantStyles = {
  info: 'bg-zinc-50 dark:bg-zinc-900 border font-light',
  success: 'bg-green-50 text-green-800 dark:bg-green-900 dark:text-white',
  warning: 'bg-yellow-50 text-yellow-800 dark:bg-yellow-900 dark:text-white',
  error: 'bg-red-50 dark:bg-red-200 text-red-800 dark:text-black'
};
type Props = {
  variant: keyof typeof variantStyles;
  title?: React.ReactNode | string;
  message?: React.ReactNode | string;
  action?: React.ReactNode;
  className?: string;
} & React.ComponentPropsWithoutRef<'div'>;
export function Alert(t0) {
  const $ = _c(24);
  let action;
  let className;
  let message;
  let rest;
  let title;
  let variant;
  if ($[0] !== t0) {
    const {
      variant: t1,
      title: t2,
      message: t3,
      action: t4,
      className: t5,
      "aria-label": ariaLabel,
      ...t6
    } = t0;
    variant = t1;
    title = t2;
    message = t3;
    action = t4;
    className = t5;
    rest = t6;
    $[0] = t0;
    $[1] = action;
    $[2] = className;
    $[3] = message;
    $[4] = rest;
    $[5] = title;
    $[6] = variant;
  } else {
    action = $[1];
    className = $[2];
    message = $[3];
    rest = $[4];
    title = $[5];
    variant = $[6];
  }
  if (!message && !title) {
    return null;
  }
  const t1 = variant === "error" || variant === "warning" ? "alert" : "status";
  const t2 = variant === "error" ? "assertive" : "polite";
  const t3 = variantStyles[variant];
  let t4;
  if ($[7] !== className || $[8] !== t3) {
    t4 = twMerge("rounded-md p-4 text-base/7 md:text-sm/6", t3, className);
    $[7] = className;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== title) {
    t5 = title && <strong className="mb-1 block font-bold">{title}</strong>;
    $[10] = title;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== message) {
    t6 = message && <p className="m-0">{message}</p>;
    $[12] = message;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== action) {
    t7 = action && <div className="mt-2 text-center">{action}</div>;
    $[14] = action;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== rest || $[17] !== t1 || $[18] !== t2 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <div role={t1} aria-live={t2} className={t4} {...rest}>{t5}{t6}{t7}</div>;
    $[16] = rest;
    $[17] = t1;
    $[18] = t2;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}